<template>
  <div class="approval-list-container">
    <CustomLoader v-if="isBusy" :width="70"></CustomLoader>
    <b-card
      no-body
      class="border-0 shadow-sm"
      style="border-radius: 8px; overflow: hidden;"
    >
        <b-tabs v-model="activeTab" card pills @input="onTabChange">
            <!-- All Profit Loss List Tab (Index 0) -->
            <b-tab title="All Profit Loss List">
            </b-tab>
            
            <!-- Pending Tab (Index 1) -->
            <b-tab title="Approved">
            </b-tab>

             <!-- Mismatch Tab (Index 2) -->
            <b-tab title="Mismatch">
            </b-tab>
            <b-tab title="Pending">
            </b-tab>

             <!-- Analytical Tabs (Index 3+) -->
             <b-tab title="Billing Locked">
             </b-tab>
             <b-tab title="Profit">
             </b-tab>
             <b-tab :title="'Profit ' + perCon + ' ' + perVal + '%'">
             </b-tab>
             <b-tab title="Profit Locked">
             </b-tab>
             <b-tab title="Loss">
             </b-tab>
              <b-tab :title="'Loss ' + perCon + ' ' + perVal + '%'">
             </b-tab>
             <b-tab title="Loss Locked">
             </b-tab>
             <b-tab title="Normal">
             </b-tab>
        </b-tabs>

        <b-row v-if="pageType == 'Profit_less_15' || pageType == 'Loss_less_15'" class="mb-3 ml-2 mt-2">
             <b-col md="2">
                 <label>Condition</label>
                 <model-list-select
                 :list="perCondList"
                 v-model="perCon"
                 option-value="perVal"
                 option-text="perText"
                 placeholder="Select Condition"
                 @input="getData"
                  />
             </b-col>
             <b-col md="2">
                 <label>Condition Value</label>
                 <b-form-input
                 type="number"
                 placeholder="Search Condition Value"
                 v-model="perVal"
                 @input="getData"
                  />
             </b-col>
        </b-row>

      <b-card-header class="bg-white border-bottom p-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="mb-0 text-primary font-weight-bold">
            <i class="fa fa-check-circle mr-2"></i>Profit / Loss Approvals
          </h4>
          <div class="d-flex align-items-center">
             <b-input-group class="mr-3" style="width: 300px;">
              <b-input-group-prepend is-text class="bg-light border-right-0">
                <i class="fa fa-search text-muted"></i>
              </b-input-group-prepend>
              <b-form-input
                v-model="filter"
                placeholder="Search by Job No, Billing Party..."
                class="border-left-0 bg-light"
                @input="debounceSearch"
              />
              <b-input-group-append v-if="filter">
                  <b-button variant="link" class="text-muted" @click="clearFilter" style="text-decoration: none;">
                      <i class="fa fa-times"></i>
                  </b-button>
              </b-input-group-append>
            </b-input-group>
             <b-button variant="outline-primary" @click="getData">
                <i class="fa fa-refresh"></i> Refresh
            </b-button>
            <b-button variant="outline-success" class="ml-2" @click="exportToExcel">
                <i class="fa fa-file-excel-o"></i> Export
            </b-button>
             <b-button variant="primary" class="ml-2" @click="showBulkUploadModal">
                <i class="fa fa-upload"></i> Bulk Upload
            </b-button>
             <b-button variant="info" class="ml-2" @click="openHistoryModal">
                <i class="fa fa-history"></i> Entry History
            </b-button>
             <b-button
                v-b-toggle.filter-collapse
                variant="outline-secondary"
                class="ml-2"
            >
                <i class="fa fa-filter"></i> Filters
            </b-button>
          </div>
        </div>
        
        <b-collapse id="filter-collapse" v-model="filtersVisible">
            <b-card class="bg-light border-0 mb-3">
                <b-row>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Date Type</label>
                         <model-list-select
                            :list="dateTypeOptions"
                            v-model="filters.dateType"
                            option-value="value"
                            option-text="text"
                            placeholder="Select Date Type"
                            @input="onFilterChange"
                          />
                     </b-col>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Date Range</label>
                          <date-range-picker
                            ref="picker"
                            :opens="openLeft"
                            v-model="dateRange"
                            :startDate="dateRange.startDate"
                            :endDate="dateRange.endDate"
                            @update="onFilterChange"
                            class="w-100"
                          >
                             <template slot="input" slot-scope="picker">
                                <div class="d-flex align-items-center form-control" style="min-width: 250px;">
                                    <i class="fa fa-calendar mr-2 text-muted"></i>
                                    <span v-if="picker.startDate && picker.endDate">
                                        {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}
                                    </span>
                                    <span v-else class="text-muted">Select Date Range</span>
                                    <i class="fa fa-caret-down ml-auto text-muted"></i>
                                </div>
                            </template>
                          </date-range-picker>
                     </b-col>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Branch</label>
                         <model-list-select
                            :list="$store.getters['common/getAllBranchList']"
                            v-model="filters.branchfilter"
                            option-value="pickupId"
                            option-text="pickupLocation"
                            placeholder="Select Branch"
                            @input="onFilterChange"
                          />
                     </b-col>
                      <b-col md="3" class="mb-3">
                        <label class="small text-muted font-weight-bold">Client</label>
                        <model-list-select
                            :list="$store.getters['common/getAllClientList']"
                            v-model="filters.clientFilter"
                            option-value="clientId"
                            option-text="clientName"
                            placeholder="Select Client"
                            @input="onFilterChange"
                         />
                    </b-col>
                    <b-col md="3" class="mb-3">
                        <label class="small text-muted font-weight-bold">Shipping Line</label>
                        <model-list-select
                            :list="$store.getters['common/getAllShippingLineList']"
                            v-model="filters.slineFilter"
                            option-value="shippingId"
                            option-text="shippingLine"
                            placeholder="Select Shipping Line"
                            @input="onFilterChange"
                         />
                    </b-col>
                     <b-col md="3" class="mb-3">
                        <label class="small text-muted font-weight-bold">User</label>
                        <model-list-select
                            :list="$store.getters['common/getAllUserList']"
                            v-model="filters.userFilter"
                            option-value="userId"
                            option-text="employeeName"
                            placeholder="Select User"
                            @input="onFilterChange"
                         />
                    </b-col>
                     <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Transport Type</label>
                          <model-list-select
                            :list="transportOptions"
                            v-model="filters.transportType"
                            option-value="value"
                            option-text="text"
                            placeholder="Select Transport Type"
                            @input="onFilterChange"
                           />
                     </b-col>
                      <b-col md="3" class="mb-3">
                         <label class="small text-muted font-weight-bold">Remark</label>
                          <model-list-select
                            :list="$store.getters['common/getAllRemarkDDList']"
                            v-model="filters.remarkFilter"
                            option-value="label"
                            option-text="label"
                            placeholder="Search & Select Remark"
                            @searchchange="searchRemark"
                            @input="debounceSearch"
                        />
                     </b-col>
                      <b-col md="3" class="d-flex align-items-end mb-3">
                         <b-button variant="outline-danger" size="sm" @click="clearFilters" block>
                            <i class="fa fa-times mr-1"></i> Clear Filters
                         </b-button>
                     </b-col>
                </b-row>
            </b-card>
        </b-collapse>
       
      </b-card-header>

      <b-card-body class="p-0">
            <b-row class="mx-3 mt-3 mb-2">
                <b-col md="3" class="mb-2">
                    <b-card class="shadow-sm border-0 summary-card">
                        <div class="small text-muted">Total Expense Amt</div>
                        <div class="h5 mb-0 font-weight-bold text-danger">
                            {{ formatSummaryAmount(totalExpenseAmt) }}
                        </div>
                    </b-card>
                </b-col>
                <b-col md="3" class="mb-2">
                    <b-card class="shadow-sm border-0 summary-card">
                        <div class="small text-muted">Total Inv Amt</div>
                        <div class="h5 mb-0 font-weight-bold text-primary">
                            {{ formatSummaryAmount(totalInvAmt) }}
                        </div>
                    </b-card>
                </b-col>
                <b-col md="3" class="mb-2">
                    <b-card class="shadow-sm border-0 summary-card">
                        <div class="small text-muted">Total Profit</div>
                        <div
                          class="h5 mb-0 font-weight-bold"
                          :class="totalProfit >= 0 ? 'text-success' : 'text-danger'"
                        >
                            {{ formatSummaryAmount(totalProfit) }}
                        </div>
                    </b-card>
                </b-col>
                <b-col md="3" class="mb-2">
                    <b-card class="shadow-sm border-0 summary-card">
                        <div class="small text-muted">Total Profit %</div>
                        <div
                          class="h5 mb-0 font-weight-bold"
                          :class="totalProfitPercent >= 0 ? 'text-success' : 'text-danger'"
                        >
                            {{ formatSummaryPercent(totalProfitPercent) }}
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-table
                :items="items"
                :fields="fields"
                responsive
                show-empty
                hover
                head-variant="light"
                class="mb-0 custom-table"
            >
                <template slot="empty">
                    <div class="text-center text-muted my-5">
                        <i class="fa fa-inbox fa-3x mb-3"></i>
                        <p>No records found.</p>
                    </div>
                </template>
                
                <!-- Custom Slots -->
                <template slot="SN" slot-scope="row">
                    <span>{{ row.index + 1 + (currentPage - 1) * perPage }}</span>
                </template>
                
                <!-- Custom Column Formatting -->
                <template slot="JobNo" slot-scope="row">
                    <!-- {{ row.item }} -->
                     <span class="truncate-text" v-b-tooltip.hover :title="row.item.JobNo || row.item.SalesSeries">Job No : {{ truncateWithEllipsis(row.item.JobNo || row.item.SalesSeries, 15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.JobDate">Job Date : {{ row.item.JobDate }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.RaisedBy">Raised By : {{ truncateWithEllipsis(row.item.RaisedBy,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.RasiedFrom">Raised From : {{ truncateWithEllipsis(row.item.RasiedFrom,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.vessel_voyage">Vessel : {{ truncateWithEllipsis(row.item.vessel_voyage,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.HBLNO">Hbl No : {{ truncateWithEllipsis(row.item.HBLNO,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.MBLNO">Mbl No : {{ truncateWithEllipsis(row.item.MBLNO,15) }}</span>
                </template>

                 <template slot="Profit" slot-scope="row">
                    <div class="text-nowrap">
                        <span :class="row.item.Profit >= 0 ? 'text-success' : 'text-danger'" class="font-weight-bold">
                            {{ row.item.Profit }}
                        </span>
                    </div>
                </template>

                 <template slot="ProfitPercent" slot-scope="row">
                    <div class="text-nowrap">
                        <span :class="row.item.ProfitPercent >= 0 ? 'text-success' : 'text-danger'" class="font-weight-bold">
                            {{ row.item.ProfitPercent }}%
                        </span>
                    </div>
                </template>

                 <!-- <template slot="ApprovalStatus" slot-scope="row">
                    <b-badge
                        :variant="getStatusVariant(row.item.ApprovalStatus)"
                        class="p-2 px-3 badge-pill"
                    >
                        {{ row.item.ApprovalStatus }}
                    </b-badge>
                </template> -->

                 <template slot="IsMismatch" slot-scope="row">
                    <b-badge
                        :variant="row.item.IsMismatch ? 'warning' : 'success'"
                        class="p-2 px-3 badge-pill"
                    >
                        {{ row.item.IsMismatch ? 'Yes' : 'No' }}
                    </b-badge>
                </template>
                <template slot="POR" slot-scope="row">
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.POR">POR : {{ truncateWithEllipsis(row.item.POR,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.POL">POL : {{ truncateWithEllipsis(row.item.POL,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.POD">POD : {{ truncateWithEllipsis(row.item.POD,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.FPOD">FPOD : {{ truncateWithEllipsis(row.item.FPOD,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.PICK">PICK : {{ truncateWithEllipsis(row.item.PICK,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.STUFF">STUFF : {{ truncateWithEllipsis(row.item.STUFF,15) }}</span>
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.HAND">HAND : {{ truncateWithEllipsis(row.item.HAND,15) }}</span>
                       
                    
                </template>

                 <template slot="clientName" slot-scope="row">
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.clientName">
                       Client : {{ truncateWithEllipsis(row.item.clientName,15) }}<br></span>
                     <span class="truncate-text" v-b-tooltip.hover :title="row.item.shippingLine">  Sline : {{ truncateWithEllipsis(row.item.shippingLine,15) }}<br></span>
                    <span class="font-weight-bold text-dark">Mbl Date : </span>{{ row.item.MblDate }}<br>
                    <span class="font-weight-bold text-dark">Mbl Release Date : </span>{{ row.item.MblReleaseDate }}<br>
                    <span class="font-weight-bold text-dark">SOB : </span>{{ row.item.Sob }}<br>
                    <span class="font-weight-bold text-dark">EtaEstimated : </span>{{ row.item.EtaEstimated }}<br>
                    <span class="font-weight-bold text-dark">EtaActual : </span>{{ row.item.EtaActual }}<br>
                </template>

                 <template slot="Remarks" slot-scope="row">
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.Remarks">
                        {{ truncateWithEllipsis(row.item.Remarks,15) }}
                    </span>
                </template>
                 <template slot="Description" slot-scope="row">
                    <span class="truncate-text" v-b-tooltip.hover :title="row.item.Description">
                        {{ truncateWithEllipsis(row.item.Description,15) }}
                    </span>
                </template>

                 <template slot="actions" slot-scope="row">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center mb-1">
                             <b-button 
                                size="sm" 
                                variant="outline-info" 
                                @click="openModal('doc', row.item)" 
                                class="mr-1 btn-action"
                                v-b-tooltip.hover title="Summary & Documents"
                            >
                            <i class="fa fa-file-text"></i>
                            </b-button>

                            <JobWisePaymentsDetails 
                                v-if="row.item.allModuleId"
                                :allModuleId="Number(row.item.allModuleId)" 
                                :JobNo="row.item.JobNo"
                                :isIcon="true"
                                iconClass="fa fa-money"
                            />

                            <Assignment-Summary 
                                 v-if="row.item.allModuleId"
                                :title="'Shipment Summary Tracking'" 
                                :assign_date="moment(row.item.CreatedTime).format('DD/MM/YYYY')"
                                :assign_job_type="row.item.jobType || ''" 
                                :assign_raised_from="'Raised From: ' + (row.item.BranchName || '')"
                                :assign_raised_by="'Raised By: ' + (row.item.CreatedBy || '')" 
                                :fk_all_module_id="row.item.allModuleId"
                                :jb_series="row.item.JobNo" 
                                :fk_client_id="row.item.clientId"
                                :fk_pod_id="row.item.PODLocationId" 
                                :isIcon="true"
                                iconClass="fa fa-truck"
                            />
                        </div>

                        <div class="d-flex align-items-center">
                            <InvExpSummary 
                                v-if="row.item.allModuleId"
                                :PMC_title="'Inv Exp Summary Job No - ' + row.item.JobNo"
                                :PMC_JOBID="String(row.item.allModuleId)" 
                                :PMC_JOBNO="row.item.JobNo"
                                :PMC_JOBDATE="moment(row.item.CreatedTime).format('DD/MM/YYYY')" 
                                :PMC_JOBTYPE="row.item.jobType || ''" 
                                :PMC_AgentType="''"
                                :PMC_Client="row.item.BillingParty" 
                                :PMC_Sline="row.item.shippingLine || ''"
                                :isIcon="true"
                                iconClass="fa fa-list-alt"
                            />

                            <ContainerSummary 
                                v-if="row.item.allModuleId"
                                :PMC_title="'Container Summary Job No - ' + row.item.JobNo"
                                :PMC_JOBID="String(row.item.allModuleId)" 
                                :PMC_JOBNO="row.item.JobNo"
                                :PMC_JOBDATE="moment(row.item.CreatedTime).format('DD/MM/YYYY')" 
                                :PMC_JOBTYPE="row.item.jobType || ''" 
                                :PMC_AgentType="''"
                                :PMC_Client="row.item.BillingParty" 
                                :PMC_Sline="row.item.shippingLine || ''"
                                :isIcon="true"
                                iconClass="fa fa-cube"
                            />

                            <b-button 
                                size="sm" 
                                variant="outline-success" 
                                @click="approve(row.item, row.index)" 
                                class="mr-1 btn-action"
                                v-b-tooltip.hover title="Approve"
                            >
                            <i class="fa fa-check"></i>
                            </b-button>

                            <ProfitLossLogModal
                                :PMC_JOBID="String(row.item.id ||row.item.fk_pl_id || row.item.pl_id || row.item.pla_id || '')"
                                :PMC_JOBNO="row.item.JobNo || row.item.SalesSeries"
                                :PMC_title="'Log Records'"
                                :clientName="row.item.BillingParty"
                            />
                        </div>
                    </div>
                 </template>
            </b-table>
      </b-card-body>

      <b-card-footer class="bg-white border-top py-3">
          <div class="d-flex justify-content-between align-items-center">
             <div class="text-muted small">
                 Showing {{ items.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }} to {{ Math.min(currentPage * perPage, totalRows) }} of {{ totalRows }} entries
             </div>
             <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                class="mb-0 custom-pagination"
                @change="onPageChange"
                pills
            ></b-pagination>
          </div>
      </b-card-footer>
    </b-card>

    <!-- Modals -->
     <b-modal :visible="activeModal === 'doc'" @hidden="activeModal = null" size="xl" hide-footer title="Summary & Documents">
        <div v-if="selectedItem && activeModal === 'doc'">
          <doc-form :allModuleIdProp="selectedItem.allModuleId" :JOBSERIES="selectedItem.JobNo" />
        </div>
    </b-modal>
    


    <b-modal :visible="activeModal === 'approve'" @hidden="activeModal = null" title="Approve Profit & Loss" size="md">
        <div v-if="selectedItem">
            <p><strong>Job No:</strong> {{ selectedItem.JobNo }}</p>
            <b-form-group label="Standard Remarks">

                 <CustomMultiSelect
                    :options="$store.getters['common/getAllRemarkDDList']"
                    :selected-options="selectedStandardRemarksItems"
                    v-model="selectedStandardRemark"
                    placeholder="Search & Select Remark"
                    :multiple="true"
                    @select="onStandardRemarkSelect"
                  ></CustomMultiSelect>
            </b-form-group>
            <b-form-group label="Remarks (Optional)">
                <b-form-textarea
                    v-model="approvalRemarks"
                    placeholder="Enter validation remarks..."
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
            </b-form-group>
        </div>
        <template slot="modal-footer">
            <b-button variant="secondary" @click="activeModal = null">Cancel</b-button>
            <b-button variant="success" @click="submitApproval">
                <i class="fa fa-check"></i> Approve
            </b-button>
        </template>
    </b-modal>

    <!-- Bulk Upload Modal -->
    <b-modal
      v-model="showBulkModal"
      title="Bulk Upload Profit Loss Remarks"
      size="lg"
      hide-footer
    >
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="flex-grow-1 mr-3">
          <b-form-file
            v-model="uploadFile"
            :state="Boolean(uploadFile)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            accept=".xlsx, .xls"
            @change="handleFileUpload"
          ></b-form-file>
        </div>
      </div>

       <b-alert v-if="uploadError" show variant="danger" dismissible @dismissed="uploadError=''">{{ uploadError }}</b-alert>
       <b-alert v-if="uploadSuccess" show variant="success" dismissible @dismissed="uploadSuccess=''">{{ uploadSuccess }}</b-alert>

      <div v-if="uploadPreview.length > 0" class="mt-3">
        <h5>Preview ({{ uploadPreview.length }} records)</h5>
         <b-table striped hover :items="uploadPreview" :fields="['jobNo', 'remark', 'remark_description']" small responsive style="max-height: 300px; overflow-y: auto;"></b-table>
          <div class="text-right mt-2">
            <b-button variant="primary" @click="submitBulkUpload" :disabled="uploadLoading">
              <b-spinner small v-if="uploadLoading"></b-spinner>
              {{ uploadLoading ? 'Uploading...' : 'Submit Upload' }}
            </b-button>
          </div>
      </div>
    </b-modal>
    
    <ProfitLossHistoryModal ref="historyModal" />
  </div>
</template>

<script>
import ProfitLossService from "../../services/ProfitLossService";
import { ModelListSelect } from "vue-search-select";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import CustomLoader from "../common/customLoader.vue";
import DocForm from "../allModuleForm/docLibrary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import ProfitLossLogModal from "./ProfitLossLogModal.vue";
import ProfitLossHistoryModal from "./ProfitLossHistoryModal.vue";
import CustomMultiSelect from "../common/CustomMultiSelect.vue";
import { lastVisitPage } from "../../helper/collection";
import { exportProfitLossListToExcel } from "../../helper/ExcelExportHelper";
import * as XLSX from "xlsx";

export default {
  components: {
    DateRangePicker,
    ModelListSelect,
    CustomLoader,
    DocForm,
    JobWisePaymentsDetails,
    AssignmentSummary,
    InvExpSummary,
    ContainerSummary,
    ProfitLossLogModal,
    // ProfitLossLogModal,
    ProfitLossHistoryModal,
    CustomMultiSelect
  },
  beforeMount() {
     lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch("common/setAllRemarkDDList", { search_txt: "",ModuleType:"PL Remarks" });
    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.$store.dispatch("common/setAllBranchList", JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
     this.$store.dispatch("common/setAllClientList", JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch("common/setAllShippingLineList", JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch("common/setAllUserList", JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.initDateRange();
  },
  data() {
    return {
      items: [],
      summaryItems: [],
      allProfitLossData: [], // Store all data for client-side filtering
      pageType: 'All', // Default page type
      perVal: 15,
      perCon: "<",
      perCondList: [
        { perVal: ">", perText: ">" },
        { perVal: ">=", perText: ">=" },
        { perVal: "<", perText: "<" },
        { perVal: "<=", perText: "<=" },
      ],
      fields: [
        { key: "SN", label: "SN", thClass: 'text-center align-middle', tdClass: 'text-center align-middle' },
        { key: "actions", label: "Actions", thClass: 'text-center align-middle sticky-action-col', tdClass: 'text-center align-middle sticky-action-col' },
        { key: "Expenses", label: "Expense", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "Incomes", label: "Income", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "Profit", label: "Profit", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "ProfitPercent", label: "Profit %", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "IsMismatch", label: "Mismatch", thClass: 'text-center align-middle', tdClass: 'text-center align-middle' },
        // { key: "ApprovalStatus", label: "Status", thClass: 'text-center align-middle', tdClass: 'text-center align-middle' },
        { key: "ApproverName", label: "Approver", thClass: 'align-middle', tdClass: 'align-middle' },
        
        { key: "Remarks", label: "Remarks", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "Description", label: "Description", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "JobNo", label: "Job Details", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "POR", label: "Location", thClass: 'align-middle', tdClass: 'align-middle', sortable: true },
        { key: "clientName", label: "Client/Sline", thClass: 'align-middle', tdClass: 'align-middle', sortable: true },
        { key: "CreatedBy", label: "Created By", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "CreatedTime", label: "Created At", thClass: 'align-middle', tdClass: 'align-middle' },
        { key: "updatedAt", label: "Updated At", thClass: 'align-middle', tdClass: 'align-middle' },
    ],
    
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: "",
      debounce: null,
      filtersVisible: false,
      activeTab: 1, // Default to Pending (Index 1)
      filters: {
          branchfilter: "",
          transportType: null,
          clientFilter: "",
          slineFilter: "",
          userFilter:"",
          remarkFilter: "",
          dateType: "loginTime"
      },
      dateTypeOptions: [
        { value: 'pl_created_at', text: 'Profit Loss Date' },
        { value: 'loginTime', text: 'Job Date' }
      ],
      dateRange: { startDate: null, endDate: null },
      transportOptions: [
          { value: 'Export', text: 'Export' },
          { value: 'Import', text: 'Import' }
      ],
      openLeft: 'right',
      // Modal Data
      selectedItem: null,
      activeModal: null,
      approvalRemarks: '',
      selectedStandardRemark: '',
      selectedStandardRemarksItems: [],
      selectedStandardRemarkText: '',
      // Bulk Upload Data
      showBulkModal: false,
      uploadFile: null,
      uploadPreview: [],
      uploadError: "",
      uploadSuccess: "",
      uploadLoading: false,
    };
  },
  mounted() {
    // Set default date range
    this.initDateRange();
    this.$nextTick(() => {
        this.getData();
    });
  },
  computed: {
      hasFilters() {
          return this.filters.branchfilter || this.filters.transportType || this.filters.clientFilter || this.filters.slineFilter || this.filters.userFilter || this.filters.remarkFilter || this.filters.dateType;
      },
      totalExpenseAmt() {
        return this.summaryItems.reduce((sum, item) => sum + this.parseNumber(item.Expenses), 0);
      },
      totalInvAmt() {
        return this.summaryItems.reduce((sum, item) => sum + this.parseNumber(item.Incomes), 0);
      },
      totalProfit() {
        return this.totalInvAmt - this.totalExpenseAmt;
      },
      totalProfitPercent() {
        if (!this.totalExpenseAmt) return 0;
        return (this.totalProfit / this.totalExpenseAmt) * 100;
      },
  },
  
  methods: {
    getCommonListPayload(isAll = 0, page = this.currentPage, pageSize = this.perPage) {
      const payload = {
        page,
        pageSize,
        search: this.filter,
        search_txt: this.filter,
        from_date: this.dateRange.startDate ? moment(this.dateRange.startDate).format("YYYY-MM-DD") : null,
        to_date: this.dateRange.endDate ? moment(this.dateRange.endDate).format("YYYY-MM-DD") : null,
        is_all: isAll,
        Filters: {
          transportType: this.filters.transportType,
          branchFilter: this.filters.branchfilter,
          clientFilter: this.filters.clientFilter,
          slineFilter: this.filters.slineFilter,
          userFilter: this.filters.userFilter,
          remarkFilter: this.filters.remarkFilter,
          dateType: this.filters.dateType,
        },
      };
      if (this.filters.branchfilter) payload.branch = this.filters.branchfilter;
      if (this.filters.clientFilter) payload.billing_party = this.filters.clientFilter;
      if (this.filters.transportType) payload.transportType = this.filters.transportType;
      if (this.filters.slineFilter) payload.shippingLine = this.filters.slineFilter;
      if (this.filters.userFilter) payload.user = this.filters.userFilter;
      if (this.filters.remarkFilter) payload.remark = this.filters.remarkFilter;
      return payload;
    },
    getPendingPayload(pageNo = this.currentPage, pageSize = this.perPage) {
      let isApproved = 0;
      let isMismatch = undefined;
      if (this.activeTab === 1) {
        isApproved = 1;
      } else if (this.activeTab === 2) {
        isApproved = 1;
        isMismatch = 1;
      } else if (this.activeTab === 3) {
        isApproved = 0;
        isMismatch = 0;
      }
      return {
        pageNo,
        pageSize,
        isAll: 0,
        search_txt: this.filter,
        Filters: {
          transportType: this.filters.transportType,
          branchFilter: this.filters.branchfilter,
          clientFilter: this.filters.clientFilter,
          slineFilter: this.filters.slineFilter,
          userFilter: this.filters.userFilter,
          remarkFilter: this.filters.remarkFilter,
          dateType: this.filters.dateType,
        },
        dateRange: this.dateRange,
        isApproved,
        isMismatch,
      };
    },
    async updateSummaryFromApi() {
      try {
        if (this.activeTab !== 1 && this.activeTab !== 2 && this.activeTab !== 3) {
          const isAll = this.activeTab > 3 ? 1 : 0;
          const summaryPayload = this.getCommonListPayload(isAll, 1, 100000);
          const summaryResponse = await ProfitLossService.getProfitLossList(summaryPayload);
          const records = summaryResponse.data.data.records || [];
          const normalized = records.map(this.normalizeAllProfitLossRecord);
          this.summaryItems = this.activeTab > 3 ? this.getFilteredData(normalized, this.pageType) : normalized;
        } else {
          const summaryPayload = this.getPendingPayload(1, 100000);
          const summaryResponse = await ProfitLossService.getPendingApprovals(summaryPayload);
          const allData = summaryResponse.data.data.data || summaryResponse.data.data || [];
          const normalized = Array.isArray(allData)
            ? allData.map(this.normalizeAllProfitLossRecord)
            : (allData.records || []).map(this.normalizeAllProfitLossRecord);
          this.summaryItems = normalized;
        }
      } catch (e) {
        this.summaryItems = this.items || [];
      }
    },
    showBulkUploadModal() {
      this.uploadFile = null;
      this.uploadPreview = [];
      this.uploadError = "";
      this.uploadSuccess = "";
      this.showBulkModal = true;
    },
    openHistoryModal() {
        this.$refs.historyModal.open();
    },
    handleFileUpload(event) {
      this.uploadError = "";
      this.uploadSuccess = "";
      const file = event.target.files ? event.target.files[0] : null; // Handle both event types if checking b-form-file logic
      if (!file && this.uploadFile) {
          // b-form-file v-model updates uploadFile, but event might not carry it directly effectively in all versions
      }
      // Actually b-form-file @change passes event. Using the File object from v-model is safer usually or event.target.files
      const fileToRead = file || this.uploadFile;
       if (!fileToRead) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const json = XLSX.utils.sheet_to_json(worksheet);

          if (json.length === 0) {
            this.uploadError = "The uploaded file is empty.";
            return;
          }

          // Map and validate
          const mappedData = json.map((row) => ({
            jobNo: row["Job No"] || row["jobNo"],
            remark: row["Remark"] || row["remark"] || row["Main Remarks"],
            remark_description: row["Remark Description"] || row["remark_description"] || row["Remarks"] || row["description"],
          })).filter(item => item.jobNo); // Ensure jobNo exists

            if (mappedData.length === 0) {
                 this.uploadError = "No valid records found. Ensure 'Job No' column exists.";
                 this.uploadPreview = [];
                 return;
            }

          this.uploadPreview = mappedData;
        } catch (error) {
          console.error("Error parsing Excel:", error);
          this.uploadError = "Failed to parse Excel file. Please ensure it is a valid .xlsx or .xls file.";
        }
      };
      reader.readAsArrayBuffer(fileToRead);
    },
    async submitBulkUpload() {
        if (this.uploadPreview.length === 0) return;
        
        this.uploadLoading = true;
        this.uploadError = "";
        this.uploadSuccess = "";

        const payload = {
            ProfitLossData: this.uploadPreview
        };

        try {
            const response = await ProfitLossService.bulkUploadProfitLoss(payload);
             if (response.data.status === 200 || response.data.success) { // Check for both as common/standard might vary
                 this.uploadSuccess = "Bulk upload completed successfully.";
                 this.uploadPreview = [];
                 this.uploadFile = null;
                 setTimeout(() => {
                     this.showBulkModal = false;
                     this.getData();
                 }, 1500);
             } else {
                 this.uploadError = response.data.message || "Bulk upload failed.";
             }
        } catch (error) {
            console.error("Bulk upload error:", error);
             this.uploadError = "An error occurred during bulk upload.";
        } finally {
            this.uploadLoading = false;
        }
    },
    initDateRange() {
        const today = new Date();
        const currentMonth = today.getMonth();
        const currentYear = today.getFullYear();
        
        let startYear, endYear;
        
        if (currentMonth >= 3) { // April (3) or later
            startYear = currentYear;
            endYear = currentYear + 1;
        } else { // Jan, Feb, Mar
            startYear = currentYear - 1;
            endYear = currentYear;
        }

        const firstDay = new Date(startYear, 3, 1); // April 1st
        const lastDay = new Date(endYear, 2, 31); // March 31st
        
        this.dateRange = { startDate: firstDay, endDate: lastDay };
    },
    debounceSearch() {
        if (this.debounce) clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.currentPage = 1;
            this.getData();
        }, 500);
    },
    onFilterChange() {
        this.currentPage = 1;
        this.getData();
    },
    onTabChange(newTabIndex) {
        this.activeTab = newTabIndex;
        // Map index to pageType for filtering
        const typeMap = {
            0: 'All',
            1: 'Approved', 
            2: 'Mismatch',
            3: 'Pending',
            4: 'Compare',        // Billing Locked
            5: 'Profit',
            6: 'Profit_less_15',
            7: 'Profit_locked',
            8: 'Loss',
            9: 'Loss_less_15',
            10: 'Loss_locked',
            11: 'Normal'
        };
        this.pageType = typeMap[newTabIndex] || 'All';
        this.currentPage = 1;
        this.getData();
    },
    clearFilters() {
        this.filters.branchfilter = "";
        this.filters.transportType = null;
        this.filters.clientFilter = "";
        this.filters.slineFilter = "";
        this.filters.userFilter = "";
        this.filters.remarkFilter = "";
        this.filters.dateType = "loginTime";
        this.initDateRange();
        this.clearFilter();
    },
    normalizeAllProfitLossRecord(record) {
        // Helper to map getAllProfitLoss API response to table fields
        // API fields: JOBNO, clientName, totExpVal, totInvVal, totPLVal, totPLPercentage, is_pl_approved, etc.
        var mainSales = record.main_sales_execution_relation || {};
        var clientDetails = mainSales.ms_clientdetail_relation || {};
        var branchDetails = mainSales.ms_branch_relation || {};
        var cuRelation = record.pl_cu_relation || {};

        return Object.assign({}, record, {
            JobNo: record.JOBNO || record.jobNo || record.pl_job_no || '',
            allModuleId: record.allModuleId || record.pl_all_module_id || mainSales.allModuleId,
            jobType: record.jobType || mainSales.jobType || '',
            clientId: record.clientId || mainSales.clientId || '',
            PODLocationId: record.PODLocationId || mainSales.PODLocationId || '', 
            shippingLine: record.shippingLine || mainSales.shippingLine || '',
            FromDate: record.fromDate || record.pl_from_date || '',
            ToDate: record.toDate || record.pl_to_date || '',
            BillingParty: record.clientName || record.BillingParty || record.pl_billing_party || clientDetails.clientName || '',
            Expenses: (record.totExpVal !== undefined) ? record.totExpVal : (record.pl_expenses || 0),
            Incomes: (record.totInvVal !== undefined) ? record.totInvVal : (record.pl_incomes || 0),
            Profit: (record.totPLVal !== undefined && typeof record.totPLVal !== 'boolean') ? record.totPLVal : (record.profit || record.pl_profit || 0),
            ProfitPercent: record.totPLPercentage || 0,
            IsMismatch: 0, // Not provided in list API
            ApprovalStatus: record.is_pl_approved || (record.pl_is_active ? 'Active' : 'Inactive'),
            ApproverName: '', // Not provided
            CreatedBy: record.RaisedBy || record.USER || cuRelation.employeeName || '',
            CreatedTime: record.createdAt || record.pl_created_at,
            updatedAt: record.updatedAt || record.pl_updated_at,
            BranchName: record.Branch || record.branch || branchDetails.pickupLocation || '',
            TransportType: record.transportType || mainSales.transportType || '',
            Remarks: record.Remarks || record.assignmentCloseReason || record.pl_remarks || '',
            Description: record.Description || record.pl_description || '',
            // Additional Date Fields from TAT/MainSales
            Sob: record.Sob || record.SOB || record.SobDate || mainSales.SOB || '',
            EtaEstimated: record.EtaEstimated || record.SysETA_estimated || mainSales.SysETA_estimated || '',
            EtaActual: record.EtaActual || record.SysETA_actual || mainSales.SysETA_actual || '',
            MblDate: record.MblDate || record.MBLDate || mainSales.mbl_date || '',
            MblReleaseDate: record.MblReleaseDate || record.MBLReleaseDate || mainSales.mbl_release_date || '',
        });
    },
    searchRemark(val) {
      this.$store.dispatch("common/setAllRemarkDDList", { search_txt: val,ModuleType:"PL Remarks" });
    },
    onStandardRemarkSelect(items) {
      this.selectedStandardRemarksItems = items;
      
      this.selectedStandardRemark = "";
      this.selectedStandardRemarkText = "";
      
      if (this.selectedStandardRemarksItems && this.selectedStandardRemarksItems.length > 0) {
        // Create comma separated string of IDs
        this.selectedStandardRemark = this.selectedStandardRemarksItems.map(item => item.value).join(',');
        
        // Create comma separated string of Labels
        this.selectedStandardRemarkText = this.selectedStandardRemarksItems.map(item => item.label).join(',');
      }
      console.log('Selected Remarks:', this.selectedStandardRemark, this.selectedStandardRemarkText);
    },
    async getData() {
      this.isBusy = true;
      try {
        this.summaryItems = [];
        let response;
        if (this.activeTab !== 1 && this.activeTab !== 2 && this.activeTab !== 3) {
            // All Profit Loss List API & New Analytical Tabs
            // Fetch ALL data if analytical tab selected (index > 2), or standard paginated ALL list (index 0)
            const isAll = this.activeTab > 2 ? 1 : 0;
            const payload = this.getCommonListPayload(isAll);
            response = await ProfitLossService.getProfitLossList(payload);
        } else {
             // Pending/Mismatch API
            const payload = this.getPendingPayload();
            response = await ProfitLossService.getPendingApprovals(payload);
        }

        if (response.data.status === 200 || response.data.type === 'success' || response.data.success) {
             if (this.activeTab === 0) {
                 const responseData = response.data.data;
                 if (responseData && responseData.records) {
                      const normalized = responseData.records.map(this.normalizeAllProfitLossRecord);
                      this.items = normalized;
                      this.summaryItems = normalized;
                      this.totalRows = responseData.pagination ? responseData.pagination.totalCount : (responseData.records.length);
                 } else {
                      this.items = [];
                      this.summaryItems = [];
                      this.totalRows = 0;
                 }
             } else if (this.activeTab > 3) {
                  const responseData = response.data.data;
                  if (responseData && responseData.records) {
                       const allRecords = responseData.records.map(this.normalizeAllProfitLossRecord);
                       this.allProfitLossData = allRecords;
                       
                       // Filter Locally using pageType
                       const filtered = this.getFilteredData(allRecords, this.pageType);
                       this.summaryItems = filtered;
                       
                       this.totalRows = filtered.length;
                       // Client-side pagination
                       const start = (this.currentPage - 1) * this.perPage;
                       this.items = filtered.slice(start, start + this.perPage);
                  } else {
                       this.items = [];
                       this.summaryItems = [];
                       this.totalRows = 0;
                  }
             } else {
                 const allData = response.data.data.data;
                 this.items = allData;
                 this.summaryItems = Array.isArray(allData) ? allData.map(this.normalizeAllProfitLossRecord) : [];
                 this.totalRows = response.data.data.pagination.count;
             }
        } else {
            this.items = [];
            this.summaryItems = [];
            this.totalRows = 0;
        }
        await this.updateSummaryFromApi();
      } catch (error) {
        console.error("Error fetching P&L data:", error);
       
      } finally {
        this.isBusy = false;
      }
    },
    getFilteredData(data, type) {
       // Filtering logic mimicking Dashboard
       if (type == "Compare") {
        return data.filter((item) => item._rowVariant !== "");
      } else if (type == "Profit_locked") {
        return data.filter((item) => item._rowVariant === "success");
      } else if (type == "Profit_less_15") {
        return data.filter(
          (item) =>
            // eval(item.totPLPercentage + this.perCon + this.perVal) && // eval is risky/discouraged usually, but strictly following dashboard logic
            this.checkCondition(item.ProfitPercent, this.perCon, this.perVal) &&
            item.Expenses > 0 &&
            item.totPLLabel === "Profit"
        );
      } else if (type == "Loss_less_15") {
        return data.filter(
          (item) =>
            this.checkCondition(Math.abs(item.ProfitPercent), this.perCon, this.perVal) &&
            item.Expenses > 0 &&
            item.totPLLabel === "Loss"
        );
      } else if (type == "Loss_locked") {
        return data.filter((item) => item._rowVariant === "danger");
      } else if (type == "Normal") {
         return data.filter((item) => item.totPLLabel === "Normal" || (!item.totPLLabel && !item._rowVariant)); // Fallback if label missing
      } else {
        return data.filter((item) => item.totPLLabel === type);
      }
    },
    checkCondition(value, operator, threshold) {
        value = Number(value);
        threshold = Number(threshold);
        switch(operator) {
            case '>': return value > threshold;
            case '>=': return value >= threshold;
            case '<': return value < threshold;
            case '<=': return value <= threshold;
            default: return false;
        }
    },

    onPageChange(page) {
        this.currentPage = page;
        this.getData();
    },
    clearFilter() {
        this.filter = "";
        this.getData();
    },
    getStatusVariant(status) {
        if (status === 'Approved') return 'success';
        if (status === 'Rejected') return 'danger';
        return 'warning';
    },
    approve(item, index) {
        this.selectedItem = item;
        // this.approvalRemarks = item.Remarks || ''; // Pre-fill if needed, or empty
        this.activeModal = 'approve';
    },
    async submitApproval() {
        if (!this.selectedItem) return;
        console.log("Selected Item:", this.selectedItem);
        
        this.isBusy = true;
        try {
            const payload = { 
                fk_pl_id: this.selectedItem.id || this.selectedItem.fk_pl_id,
                pla_id: this.selectedItem.pla_id || this.selectedItem.pla_id,
                remarks: this.approvalRemarks,
                fk_doc_id: this.selectedStandardRemark.map(item => item.value).join(',') || '',
                doc_value: this.selectedStandardRemarkText || '',
                status: 'Approved',
                type: this.activeTab, // 0 for all, 1 for Approved, 2 for mismatch
            };
            const response = await ProfitLossService.approveProfitLoss(payload);
             if (response.data.status === 200 || response.data.type === 'success') {
                console.log("P&L Entry Approved Successfully");
                this.activeModal = null;
                this.getData();
             } else {
                 this.isBusy = false;
             }
        } catch (error) {
             console.log("Error approving P&L entry", error);
             this.isBusy = false;
        }
    },
    async exportToExcel() {
      this.isBusy = true;
      try {
        let response;
        let exportData = [];
        const exportPageSize = 100000; // Large number to get all

        if (this.activeTab !== 1 && this.activeTab !== 2 && this.activeTab !== 3) {
            // All Profit Loss List API & Analytical Tabs
            const isAll = this.activeTab > 3 ? 1 : 0;
            const payload = this.getCommonListPayload(isAll, 1, exportPageSize);
            
            response = await ProfitLossService.getProfitLossList(payload);
             if (response.data.status === 200 || response.data.type === 'success' || response.data.success) {
                  const responseData = response.data.data;
                  if (responseData && responseData.records) {
                       const allRecords = responseData.records.map(this.normalizeAllProfitLossRecord);
                       
                       if (this.activeTab > 3) {
                           // Apply client-side filtering for analytical tabs
                           exportData = this.getFilteredData(allRecords, this.pageType);
                       } else {
                           exportData = allRecords;
                       }
                  }
             }

        } else {
            const payload = this.getPendingPayload(1, exportPageSize);
            response = await ProfitLossService.getPendingApprovals(payload);
            if (response.data.status === 200 || response.data.type === 'success' || response.data.success) {
                 const allData = response.data.data.data || response.data.data; // Handle potential structure diff
                 if (Array.isArray(allData)) {
                     exportData = allData.map(this.normalizeAllProfitLossRecord);
                 } else if (allData && allData.records) {
                     exportData = allData.records.map(this.normalizeAllProfitLossRecord);
                 }
            }
        }
        
        if (exportData.length > 0) {
            exportProfitLossListToExcel(exportData, `ProfitLossReport_${this.pageType}.xlsx`);
        } else {
             this.$bvToast.toast('No data to export', {
                title: 'Export Info',
                variant: 'info',
                solid: true
            });
        }
      } catch (error) {
           console.error("Export Error:", error);
           this.$bvToast.toast('Failed to export', {
                title: 'Error',
                variant: 'danger',
                solid: true
            });
      } finally {
        this.isBusy = false;
      }
    },
   
    openModal(type, item) {
        this.selectedItem = item;
        this.activeModal = type;
    },
    truncateWithEllipsis(text, maxLength = 30) {
        if (!text) return "";
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + "...";
        }
        return text;
    },
    parseNumber(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    formatSummaryAmount(value) {
      return this.parseNumber(value).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatSummaryPercent(value) {
      return `${this.parseNumber(value).toFixed(2)}%`;
    },
    moment(date) {
        return moment(date);
    }
  }
};
</script>

<style scoped>
.approval-list-container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding: 20px;
}
.summary-card {
    border-radius: 8px;
}

/* Table Styles */
.custom-table {
    table-layout: fixed;
}

.custom-table ::v-deep thead th {
    border-top: none;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.85rem;
    letter-spacing: 0.5px;
    color: #495057;
    white-space: nowrap;
}

.truncate-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: block;
}

.custom-table ::v-deep tbody tr {
    transition: background-color 0.2s ease;
}

.custom-table ::v-deep tbody tr:hover {
    background-color: #f8f9fa;
}

.btn-action {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.btn-action:hover {
    transform: scale(1.1);
}

/* Search input focus */
.form-control:focus {
    box-shadow: none;
    border-color: #80bdff;
}

/* Date Range Picker Overrides */
::v-deep .vue-daterange-picker {
    width: 100% !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
}

::v-deep .vue-daterange-picker .form-control {
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
}

::v-deep .vue-daterange-picker .reportrange-text {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    display: flex;
    align-items: center;
    width: 100%;
}

::v-deep .vue-daterange-picker .reportrange-text i {
    margin-right: 8px;
    color: #6c757d;
}

/* Sticky Action Column */
::v-deep .sticky-action-col {
    position: sticky;
    right: 0;
    z-index: 100;
    background-color: white;
    box-shadow: -2px 0 5px rgba(0,0,0,0.05);
}

::v-deep thead th.sticky-action-col {
    z-index: 101;
    background-color: #e9ecef; /* Match head-variant="light" default color approx */
}

</style>



// WEBPACK FOOTER //
// ProfitLossApprovalList.vue?03bf771c